import {Component, HostBinding, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {Action} from '../../../common/model/action';
import {AppConfig} from '../../../../config/app.config';
import {Activity} from '../../../../helpers/activity';
import {BuildingIssuesService} from '../../../buildings/issues/building-issues.service';
import {CollapseComponent} from 'ng-uikit-pro-standard';
import {Multimedium} from '@npm.chapps.com/chapps.common.angular.library/lib/components/multimedium/model/multimedium';
import {MultimediaViewerService} from '@npm.chapps.com/chapps.common.angular.library';

@Component({
  selector: 'app-action-detail',
  templateUrl: './action-detail.component.html',
  styleUrl: './action-detail.component.scss',
})
export class ActionDetailComponent implements OnChanges {
  @Input()
  public action: Action;
  protected readonly activity: Activity<ActionDetailActivity> = new Activity(ActionDetailActivity);
  protected actionMedia: Multimedium[];
  @HostBinding('class.show-details')
  protected showDetails = false;
  @ViewChild('belowTheFold')
  protected belowTheFold: CollapseComponent;
  protected get issue() {
    return this.action.issues[0];
  }

  constructor(
    protected readonly config: AppConfig,
    private readonly issuesResource: BuildingIssuesService,
    private readonly multiMediaViewer: MultimediaViewerService,
  ) { }

  public async ngOnChanges(changes: SimpleChanges) {
    if (changes.action && this.issue) {
      await this.fetchActionMedia();
    }
  }

  private async fetchActionMedia() {
    this.actionMedia = await this.loadMediaRequest;
  }

  private get loadMediaRequest() {
    const request = this.issuesResource.getPhotos(this.action.issues[0]?.issueId).toPromise();
    return this.activity
      .track(ActionDetailActivity.LoadIssueMedia)
      .operation(request)
  }

  public toggleDetails() {
    this.showDetails = !this.showDetails;
    this.belowTheFold.toggle();
  }

  public openMediaViewer(photo: Multimedium, actionMedia: Multimedium[]) {
    this.multiMediaViewer.show(actionMedia, actionMedia.indexOf(photo));
  }
}

enum ActionDetailActivity {
  LoadIssueMedia
}
